export const STEP_EDIT_STORE = 'StepEditStore';

/**
 * Step-Felder arbeiten auf einer lokalen Arbeitskopie. Upload und UI-Aktion
 * dürfen deshalb niemals selbst den fachlichen Step speichern.
 */
export function isStepDraftStore(storeName) {
    return storeName === STEP_EDIT_STORE;
}

/**
 * Persistiert eine Feldänderung nur für Editoren mit Save-on-edit-Vertrag.
 * Der StepEditor bestätigt Änderungen ausschließlich über seine zentralen
 * Abschlussaktionen.
 */
export function persistEditorFieldChange(storeName, persist) {
    if (isStepDraftStore(storeName)) return Promise.resolve(null);

    return Promise.resolve().then(persist);
}
